module.exports = __webpack_public_path__ + "static/media/trash.1b6237e3.svg";